if (!customElements.get('hz-footer-menu')) {
  class HzFooterMenu extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.items = [...this.querySelectorAll('.hz-footer-menu__item--has-children')];
      this.hoverMedia = window.matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)');
      this.abortController = new AbortController();

      const { signal } = this.abortController;

      this.items.forEach((item) => {
        const trigger = item.querySelector('.hz-footer-menu__trigger');
        if (!trigger) return;

        trigger.addEventListener('click', () => this.toggleItem(item), { signal });

        item.addEventListener('pointerenter', () => {
          if (this.hoverMedia.matches) this.openItem(item);
        }, { signal });

        item.addEventListener('pointerleave', () => {
          if (this.hoverMedia.matches && !item.contains(document.activeElement)) this.closeItem(item);
        }, { signal });

        item.addEventListener('focusin', (event) => {
          if (!this.suppressFocusOpen && event.target.matches(':focus-visible')) this.openItem(item);
        }, { signal });

        item.addEventListener('focusout', () => {
          window.requestAnimationFrame(() => {
            if (!item.contains(document.activeElement)) this.closeItem(item);
          });
        }, { signal });
      });

      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        const openItem = this.querySelector('.hz-footer-menu__item.is-open');
        if (!openItem) return;

        const trigger = openItem.querySelector('.hz-footer-menu__trigger');
        this.suppressFocusOpen = true;
        this.closeItem(openItem);
        trigger?.focus({ preventScroll: true });
        window.requestAnimationFrame(() => {
          this.suppressFocusOpen = false;
        });
      }, { signal });

      this.handleMediaChange = () => this.closeAll();
      this.hoverMedia.addEventListener('change', this.handleMediaChange);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.hoverMedia?.removeEventListener('change', this.handleMediaChange);
      delete this.dataset.initialized;
    }

    toggleItem(item) {
      if (item.classList.contains('is-open')) {
        this.closeItem(item);
      } else {
        this.openItem(item);
      }
    }

    openItem(item) {
      this.items.forEach((candidate) => {
        if (candidate !== item) this.closeItem(candidate);
      });

      item.classList.add('is-open');
      item.querySelector('.hz-footer-menu__trigger')?.setAttribute('aria-expanded', 'true');
    }

    closeItem(item) {
      item.classList.remove('is-open');
      item.querySelector('.hz-footer-menu__trigger')?.setAttribute('aria-expanded', 'false');
    }

    closeAll() {
      this.items.forEach((item) => this.closeItem(item));
    }
  }

  customElements.define('hz-footer-menu', HzFooterMenu);
}
